import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { EditIcon } from "../../../assets/images/EditIcon";
import { ActionButton } from "../../common/Table/ActionButton/ActionButton";
import { Table } from "../../common/Table/Table";
import { DescriptionCell } from "./DescriptionCell/DescriptionCell";
import { OrganizationModal } from "../OrganizationModal/OrganizationModal";

export const OrganizationsTable = ({ organizations, isLoading }) => {
  const { t } = useTranslation();
  const [editModal, setEditModal] = useState({
    isOpen: false,
    organization: null,
  });

  const handleOpenEditModal = (organization) => {
    setEditModal({
      isOpen: true,
      organization,
    });
  };

  const handleCloseEditModal = () => {
    setEditModal({
      isOpen: false,
      organization: null,
    });
  };

  const columns = [
    { key: "id", header: t("common.id"), width: "60px", align: "center" },
    { key: "name", header: t("common.name"), width: "200px", align: "left" },
    {
      key: "description",
      header: t("common.description"),
      width: "300px",
      align: "left",
      wrap: true,
    },
    {
      key: "actions",
      header: t("common.actions"),
      width: "80px",
      align: "center",
    },
  ];

  const renderCustomCell = (item, key) => {
    switch (key) {
      case "description":
        return <DescriptionCell>{item.description}</DescriptionCell>;

      case "actions":
        return (
          <ActionButton
            onClick={() => handleOpenEditModal(item)}
            ariaLabel={t("organizations.editOrganization")}
            hoverColor="#4F46E5"
          >
            <EditIcon />
          </ActionButton>
        );
      default:
        return item[key] || "-";
    }
  };

  return (
    <>
      <Table
        columns={columns}
        data={organizations}
        emptyMessage={t("organizations.noOrganizationsFound")}
        loadingMessage={t("organizations.loadingOrganizations")}
        isLoading={isLoading}
        renderCustomCell={renderCustomCell}
      />

      {editModal.isOpen && (
        <OrganizationModal
          isOpen={editModal.isOpen}
          onClose={handleCloseEditModal}
          organization={editModal.organization}
        />
      )}
    </>
  );
};
